import React from "react";
import line from "../asset/main/line.svg";
import footerLogo from "../asset/main/footerLogo.svg";

function FooterM() {
  return (
    <div className="div-mainm-footer-section">
      <img className="img-mainm-footer-logo" src={footerLogo} alt="" />
      <div className="div-mainm-footer-section-01">
        <div
          className="div-main-footer-section-01-button Tag1M"
          onClick={() => (window.location.href = "/termsm")}
        >
          이용약관
        </div>
        <div
          className="div-main-footer-section-01-button Tag1M"
          onClick={() => (window.location.href = "/privacym")}
        >
          개인정보처리방침
        </div>
      </div>
      <div className="div-mainm-footer-section-02 Body5">
        <div className="div-main-footer-section-02-text">더블인터넷</div>
        <img src={line} alt="" style={{ height: "12px" }} />
        <div className="div-main-footer-section-02-text">대표 : 박승한</div>
      </div>
      <div className="div-mainm-footer-section-02 div-main-footer-section-02-text">
        대전광역시 서구 문정로 150번길 19, 3층(탄방동)
      </div>
      <div className="div-mainm-footer-section-02 div-main-footer-section-02-text">
        사업자등록번호 : 593-31-00146
      </div>
      <div className="div-mainm-footer-section-02 div-main-footer-section-02-text">
        <div className="div-main-footer-section-02-text">
          개인정보책임자: 박승한
        </div>
        <img src={line} alt="" style={{ height: "12px" }} />
        <div className="div-main-footer-section-02-text">
          이메일 : system@doubleinternet.com
        </div>
      </div>
      <div className="div-mainm-footer-section-02 div-main-footer-section-02-text">
        더블인터넷 All Rights Reserved
      </div>
    </div>
  );
}

export default FooterM;
